import { Site } from '@/types/site';
import { Zone } from '@/types/zone';
import { System } from '@/types/system';
import { Endpoint } from '@/types/endpoint';
import { CloudService } from '@/types/cloudService';
import { InternetConnection } from '@/types/internetConnection';
import { DMZConfig, FirewallRule } from '@/types/dmzConfig';
import { downloadExcelTemplateEnhanced, generateExcelExportWithData, type OrgMember } from './excelTemplateGenerator';

// Re-export the enhanced template generator with org members support
export async function downloadExcelTemplate(orgMembers?: OrgMember[]) {
  return downloadExcelTemplateEnhanced(orgMembers);
}

// Export all assets to Excel with template formatting (ExcelJS-based)
export async function exportAssetsToExcel(
  sites: Site[],
  zones: Zone[],
  systems: System[],
  endpoints: Endpoint[],
  cloudServices: CloudService[],
  orgMembers?: OrgMember[],
  internetConnections?: InternetConnection[],
  dmzConfigs?: DMZConfig[],
  firewallRules?: FirewallRule[]
) {
  const blob = await generateExcelExportWithData(
    { sites, zones, systems, endpoints, cloudServices, internetConnections, dmzConfigs, firewallRules },
    orgMembers
  );
  
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `assets_export_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
